<topaz-toast useIcon>
  <div toast-content>
    <span>{{data.name}}</span>
  </div>
</topaz-toast>
